// ==============================|| OVERRIDES - OUTLINED INPUT ||============================== //

export default function OutlinedInput(theme) {
  const isDark = theme.palette.mode === 'dark';

  return {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: '13px',
          fontWeight: 500,
          color: isDark ? '#9AA3B2' : '#475569',
          marginBottom: '4px',
          '&.Mui-focused': {
            color: isDark ? '#2DD4BF' : '#0D9488'
          },
          '&.Mui-error': {
            color: isDark ? '#F87171' : '#DC2626'
          },
          '& .MuiFormLabel-asterisk': {
            color: isDark ? '#F87171' : '#DC2626'
          }
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: '12px',
          color: isDark ? '#9AA3B2' : '#64748B',
          marginTop: '4px',
          '&.Mui-error': {
            color: isDark ? '#F87171' : '#DC2626'
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: isDark ? (theme.palette?.background?.input || '#1A1D23') : '#ffffff',
          borderRadius: '8px',
          minHeight: '40px',
          transition: 'all 0.15s ease-in-out',

          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: isDark ? (theme.palette?.border?.default || 'rgba(255, 255, 255, 0.08)') : '#CBD5E1',
            borderWidth: '1px',
            transition: 'all 0.15s ease-in-out'
          },

          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: isDark ? (theme.palette?.border?.strong || 'rgba(255, 255, 255, 0.13)') : '#94A3B8'
          },

          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#14B8A6',
            borderWidth: '1px',
            boxShadow: '0 0 0 3px rgba(20, 184, 166, 0.15)'
          },

          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: isDark ? '#F87171' : '#DC2626',
            boxShadow: isDark ? '0 0 0 3px rgba(248, 113, 113, 0.15)' : undefined
          },

          '&.Mui-disabled, &[readonly], & input[readonly]': {
            background: isDark ? `${theme.palette?.background?.card || '#20242B'} !important` : '#F8FAFC !important',
            color: isDark ? `${theme.palette?.text?.placeholder || '#707886'} !important` : '#94A3B8 !important',
            cursor: 'not-allowed !important',
            WebkitTextFillColor: isDark ? `${theme.palette?.text?.placeholder || '#707886'} !important` : '#94A3B8 !important'
          },

          '&.Mui-disabled .MuiOutlinedInput-notchedOutline, &[readonly] .MuiOutlinedInput-notchedOutline': {
            borderColor: isDark ? (theme.palette?.border?.default ? `${theme.palette.border.default} !important` : 'rgba(255, 255, 255, 0.08) !important') : '#E2E8F0 !important'
          },

          '&.MuiInputBase-multiline': {
            padding: '10px 14px'
          }
        },
        input: {
          fontWeight: 400,
          fontSize: '14px',
          color: isDark ? (theme.palette?.text?.primary || '#ECEEF1') : '#1E293B',
          background: 'transparent',
          padding: '9px 14px',
          height: '22px',
          boxSizing: 'content-box',
          '&::placeholder': {
            color: isDark ? (theme.palette?.text?.placeholder || '#707886') : '#94A3B8',
            opacity: 1
          },

          '&.MuiInputBase-inputSizeSmall': {
            padding: '9px 12px',
            fontSize: '14px'
          },

          // Webkit autofill fix
          '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
            WebkitBoxShadow: isDark ? `0 0 0 1000px ${theme.palette?.background?.input || '#1A1D23'} inset !important` : '0 0 0 1000px #ffffff inset !important',
            WebkitTextFillColor: isDark ? `${theme.palette?.text?.primary || '#ECEEF1'} !important` : '#1E293B !important',
            caretColor: isDark ? `${theme.palette?.text?.primary || '#ECEEF1'} !important` : '#1E293B !important',
            transition: 'background-color 5000s ease-in-out 0s !important'
          }
        },
        inputAdornedStart: {
          paddingLeft: 4
        },
        notchedOutline: {
          borderRadius: '8px'
        }
      }
    }
  };
}
